<template>
	<div v-if="carrera" class="carreras" :class="carrera.color">
		<div class="container">
			<div class="row">
				<div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 d-flex align-items-center">
					<div class="h1 text-white">{{ carrera.title }}</div>
				</div>
				<div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 py-5">
					<img :src="'/assets/images/iconos-carreras/' + carrera.image"
					     class="d-block w-100 rounded-circle bg-sky-blue"
					     :alt="carrera.title"/>
				</div>
			</div>
		</div>
	</div>
	<div v-if="carrera" class="border-5 border-bottom border-dark-cyan"></div>
	<div v-if="carrera" class="bg-white py-5">
		<div class="container">
			<div class="row">
				<div class="col-12 h2 text-dark-pink">
					<p class="mb-5">Selecciona tu año de ingreso</p>
				</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
					<button
						class="rounded-3 border-0 zoom-in w-100 d-block p-5 h1 text-start bg-dark-cyan text-white transitionable"
						:class="activeBackground('2020-2021')"
						@click="setSchedule('2020-2021')">
						2020-2021
					</button>
				</div>
				<div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
					<button
						class="rounded-3 border-0 zoom-in w-100 d-block p-5 h1 text-start bg-dark-cyan text-white transitionable"
						:class="activeBackground('2022')"
						@click="setSchedule('2022')">
						2022
					</button>
				</div>
			</div>
		</div>
	</div>
	<div v-if="carrera" class="bg-gray py-5">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-10">
					<div id="carousel-programas" class="carousel slide" data-bs-ride="carousel">
						<div class="carousel-inner">
							<div v-for="(_schedule, index) in selectedSchedule" class="carousel-item"
							     :class="{active: index === 0}">
								<img :src="createURLImage(_schedule.img)"
								     class="d-block w-100" alt="...">
								
								<div class="pt-5 text-center">
									<a class="btn btn-lg bg-white text-cyan rounded-pill"
									   target="_blank"
									   :href="createURLPdf(_schedule.pdf)">
										<b>Descargar</b>
									</a>
								</div>
							</div>
						</div>
						<button class="carousel-control-prev" type="button"
						        data-bs-target="#carousel-programas" data-bs-slide="prev">
							<i class="fas fa-caret-left control-prev-icon fa-fw"></i>
							<span class="visually-hidden">Previous</span>
						</button>
						<button class="carousel-control-next" type="button"
						        data-bs-target="#carousel-programas" data-bs-slide="next">
							<i class="fas fa-caret-right control-next-icon fa-fw"></i>
							<span class="visually-hidden">Next</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<banda-ver-saludos/>
</template>

<script>
import BandaVerSaludos from "../layout/BandaVerSaludos";

export default {
	name: 'programa-carrera',
	components: {
		BandaVerSaludos
	},
	mounted() {
		const carrera = this.$route.params.carrera.toString();
		if (this.carreras.hasOwnProperty(carrera)) {
			this.carrera = this.carreras[carrera];
		} else {
			this.$router.push('/programa');
		}
	},
	data: () => ({
		carrera: null,
		schedule: '2020-2021',
		carreras: {
			'forestal': {
				image: 'forestal.png',
				title: 'Ingeniería Forestal',
				color: 'forestal',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo2.jpg', pdf: 'Grupo2.pdf'},
						{img: 'H_Grupo2B.jpg', pdf: 'Grupo2.pdf'},
					],
					'2022': [
						{img: 'h._Forestal-Agronomía1.jpg', pdf: 'Grupo2.pdf'},
						{img: 'h._Forestal-Agronomía2.jpg', pdf: 'Grupo2.pdf'},
					],
				}
			},
			'agronomia': {
				image: 'agronomia.png',
				title: 'Agronomía',
				color: 'agronomia',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo2.jpg', pdf: 'Grupo2.pdf'},
						{img: 'H_Grupo2B.jpg', pdf: 'Grupo2.pdf'},
					],
					'2022': [
						{img: 'h._Forestal-Agronomía1.jpg', pdf: 'Grupo2.pdf'},
						{img: 'h._Forestal-Agronomía2.jpg', pdf: 'Grupo2.pdf'},
					],
				}
			},
			'obstetricia': {
				image: 'obstetricia.png',
				title: 'Obstetricia',
				color: 'obstetricia',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo2.jpg', pdf: 'Grupo2.pdf'},
						{img: 'H_Grupo2B.jpg', pdf: 'Grupo2.pdf'},
					],
					'2022': [
						{img: 'h._Obstetricia1.jpg', pdf: 'Grupo2.pdf'},
						{img: 'h._Obstetricia2.jpg', pdf: 'Grupo2.pdf'},
					],
				}
			},
			'enfermeria': {
				image: 'enfermeria.png',
				title: 'Enfermería',
				color: 'enfermeria',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo2.jpg', pdf: 'Grupo2.pdf'},
						{img: 'H_Grupo2B.jpg', pdf: 'Grupo2.pdf'},
					],
					'2022': [
						{img: 'h._Enfermería1.jpg', pdf: 'ENFERMERÍA.pdf'},
						{img: 'h._Enfermería2.jpg', pdf: 'ENFERMERÍA.pdf'},
					],
				}
			},
			'civil-industrial': {
				image: 'civil-industrial.png',
				title: 'Ingeniería Civil Industrial ',
				color: 'civil-industrial',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo1.jpg', pdf: 'Grupo 1.pdf'},
						{img: 'H_Grupo1B.jpg', pdf: 'Grupo 1.pdf'},
					],
					'2022': [
						{img: 'h._Ingeniería Civil Industrial.jpg', pdf: 'H.ING.INDUSTRIAL.pdf'},
						{img: 'h._Ingeniería Civil Industrial2.jpg', pdf: 'H.ING.INDUSTRIAL.pdf'},
					],
				}
			},
			'informatica': {
				image: 'informatica.png',
				title: 'Ingeniería Civil Informatica',
				color: 'informatica',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo1.jpg', pdf: 'Grupo 1.pdf'},
						{img: 'H_Grupo1B.jpg', pdf: 'Grupo 1.pdf'},
					],
					'2022': [
						{img: 'h._Informática1.jpg', pdf: 'H.ING.INFORMÁTICA.pdf'},
						{img: 'h._Informatica2.jpg', pdf: 'H.ING.INFORMÁTICA.pdf'},
					],
				},
			},
			'psicologia': {
				image: 'psicologia.png',
				title: 'Psicología',
				color: 'psicologia',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo1.jpg', pdf: 'Grupo 1.pdf'},
						{img: 'H_Grupo1B.jpg', pdf: 'Grupo 1.pdf'},
					],
					'2022': [
						{img: 'h._Psicología1.jpg', pdf: 'H.Psicología.pdf'},
						{img: 'h._Psicología2.jpg', pdf: 'H.Psicología.pdf'},
					],
				}
			},
			'trabajo-social': {
				image: 'trabajo-social.png',
				title: 'Trabajo Social',
				color: 'trabajo-social',
				schedule: {
					'2020-2021': [
						{img: 'H_Grupo1.jpg', pdf: 'Grupo 1.pdf'},
						{img: 'H_Grupo1B.jpg', pdf: 'Grupo 1.pdf'},
					],
					'2022': [
						{img: 'h._Trabajo Social1.jpg', pdf: 'H.TRABAJOSOCIAL.pdf'},
						{img: 'h._Trabajo Social2.jpg', pdf: 'H.TRABAJOSOCIAL.pdf'},
					],
				}
			},
			
		},
	}),
	methods: {
		setSchedule(schedule) {
			this.schedule = schedule;
		},
		createURLImage(image) {
			return '/assets/images/horarios/' + this.schedule + '/jpg/' + image;
		},
		createURLPdf(pdf) {
			return '/assets/images/horarios/' + this.schedule + '/pdf/' + pdf;
		},
		activeBackground(schedule) {
			if (schedule === this.schedule) {
				return 'bg-carrera-' + this.carrera.color;
			}
			return '';
		}
	},
	computed: {
		selectedSchedule() {
			return this.carrera.schedule[this.schedule];
		},
	}
	// h._PACE.jpg
}
</script>